<template>
  <div data-nosnippet>
    <div v-if="!isLoading">
      <div v-if="window.size.desktop"
           class="h-11 flex justify-center items-center border-y rounded-t-zt border-zt-light bg-[#2E3C4F]">
        <span class="uppercase text-zt-more font-medium text-center">KOD PROMOCYJNY {{ bookmakerName }}</span>
      </div>
      <PromoCodeBox v-if="window.size.desktop"
                    :promoCodeHeaderFromProps="bookmakerName"
                    :promoCodeFromProps="bookieData.code"
                    :isPromoCodeDetails="true"
                    :bonusLink="bookieData.link" />
      <div v-if="window.size.desktop"
           id="oferta_powitalna"
           class="h-11 flex justify-center items-center border-y border-zt-light bg-[#2E3C4F]">
        <span class="uppercase text-zt-more font-medium text-center">{{ bookieData.promo_section1 }}</span>
      </div>
      <div class="bg-zt-dark relative flex justify-between items-center h-[469px] xl:h-[152px]"
           :class="{ '!h-[445px] xl:!h-[152px]' : !bookieData.amount_line_through }">
        <BonusDetailsModal v-if="isMainBonusModalOpen"
                           :bookieData="bookieData"
                           :isMainBonus="true"
                           @close-modal="closeModal" />
        <div v-if="window.size.desktop"
             class="absolute rounded-md h-[86px] w-[174px] top-[38px] left-[38px] bg-cover bg-center"
             :style="{ backgroundImage: `url('/wp-content/themes/zawodtyper/assets/images/bukmacherzy/${bookmakerName.toLowerCase()}.svg')` }"></div>
	      <div v-else class="absolute top-0 left-1/2 -translate-x-1/2">
		      <img :src="`/wp-content/themes/zawodtyper/assets/images/bukmacherzy/${ bookmakerName.toLowerCase() }.svg`"
		           class="object-cover zt-hover rounded-b-[9px] border-zt-light"
		           width="128" height="77"/>
	      </div>
        <div :class="{ '!top-[203px] xl:!top-[21px]' : !bookieData.amount_line_through }"
	        class="absolute bg-zt-green flex justify-center items-center gap-[5px] p-[5px] rounded-zt
               top-[227px] left-1/2 -translate-x-1/2 xl:top-[21px] xl:left-[52px] xl:translate-x-0">
          <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.1163 5.92625C12.8806 5.68 12.6369 5.42625 12.545 5.20312C12.46 4.99875 12.455 4.66 12.45 4.33187C12.4406 3.72187 12.4306 3.03062 11.95 2.55C11.4694 2.06937 10.7781 2.05937 10.1681 2.05C9.84 2.045 9.50125 2.04 9.29688 1.955C9.07438 1.86312 8.82 1.61937 8.57375 1.38375C8.1425 0.969375 7.6525 0.5 7 0.5C6.3475 0.5 5.85812 0.969375 5.42625 1.38375C5.18 1.61937 4.92625 1.86312 4.70312 1.955C4.5 2.04 4.16 2.045 3.83187 2.05C3.22187 2.05937 2.53062 2.06937 2.05 2.55C1.56937 3.03062 1.5625 3.72187 1.55 4.33187C1.545 4.66 1.54 4.99875 1.455 5.20312C1.36312 5.42562 1.11937 5.68 0.88375 5.92625C0.469375 6.3575 0 6.8475 0 7.5C0 8.1525 0.469375 8.64187 0.88375 9.07375C1.11937 9.32 1.36312 9.57375 1.455 9.79688C1.54 10.0013 1.545 10.34 1.55 10.6681C1.55937 11.2781 1.56937 11.9694 2.05 12.45C2.53062 12.9306 3.22187 12.9406 3.83187 12.95C4.16 12.955 4.49875 12.96 4.70312 13.045C4.92562 13.1369 5.18 13.3806 5.42625 13.6163C5.8575 14.0306 6.3475 14.5 7 14.5C7.6525 14.5 8.14187 14.0306 8.57375 13.6163C8.82 13.3806 9.07375 13.1369 9.29688 13.045C9.50125 12.96 9.84 12.955 10.1681 12.95C10.7781 12.9406 11.4694 12.9306 11.95 12.45C12.4306 11.9694 12.4406 11.2781 12.45 10.6681C12.455 10.34 12.46 10.0013 12.545 9.79688C12.6369 9.57438 12.8806 9.32 13.1163 9.07375C13.5306 8.6425 14 8.1525 14 7.5C14 6.8475 13.5306 6.35812 13.1163 5.92625ZM9.85375 6.35375L6.35375 9.85375C6.30731 9.90024 6.25217 9.93712 6.19147 9.96228C6.13077 9.98744 6.06571 10.0004 6 10.0004C5.93429 10.0004 5.86923 9.98744 5.80853 9.96228C5.74783 9.93712 5.69269 9.90024 5.64625 9.85375L4.14625 8.35375C4.05243 8.25993 3.99972 8.13268 3.99972 8C3.99972 7.86732 4.05243 7.74007 4.14625 7.64625C4.24007 7.55243 4.36732 7.49972 4.5 7.49972C4.63268 7.49972 4.75993 7.55243 4.85375 7.64625L6 8.79313L9.14625 5.64625C9.19271 5.59979 9.24786 5.56294 9.30855 5.5378C9.36925 5.51266 9.4343 5.49972 9.5 5.49972C9.5657 5.49972 9.63075 5.51266 9.69145 5.5378C9.75214 5.56294 9.80729 5.59979 9.85375 5.64625C9.90021 5.6927 9.93705 5.74786 9.9622 5.80855C9.98734 5.86925 10.0003 5.9343 10.0003 6C10.0003 6.0657 9.98734 6.13075 9.9622 6.19145C9.93705 6.25214 9.90021 6.3073 9.85375 6.35375Z" fill="white" />
          </svg>
          <span class="text-[10px] font-semibold"
                @click="countClicks('Kody promocyjne - 5')"
                data-bs-toggle="tooltip" data-bs-placement="top" data-bs-delay='{"show": 100, "hide": 400}'
                title="Bonusy są aktualizowane na bieżąco">Oferta zweryfikowana</span>
        </div>
	      <div class="only-mobile absolute left-1/2 -translate-x-1/2 w-full text-center
               top-[94px]">
		      <div class="flex flex-row items-center justify-center gap-x-[9px]">
			      <hr class="border-t border-dashed border-zt-light w-[65px]" />
			      <div class="uppercase text-xs text-[#FFF] opacity-70 font-normal tracking-[0.012px]">Główna oferta powitalna</div>
			      <hr class="border-t border-dashed border-zt-light w-[65px]" />
		      </div>
	      </div>
        <div class="absolute left-1/2 -translate-x-1/2 flex flex-col items-center w-full text-center
               top-[120px] xl:w-fit xl:top-1/2 xl:-translate-y-1/2" :class="{ 'top-[100px]' : !bookieData.amount_line_through }">
          <div v-if="bookieData.amount_line_through" class="relative font-medium opacity-70">
            <div class="simple-line-through">
              {{ bookieData.amount_line_through }} PLN
            </div>
          </div>
          <span class="text-[30px] font-bold xl:-my-1.5">{{ bookieData.amount }}</span>
          <span class="font-medium opacity-70">{{ bookieData.amount_title }}</span>
        </div>
        <div class="absolute flex gap-3 bottom-6 left-1/2 -translate-x-1/2 flex-col
               xl:top-[25px] xl:right-[27px] xl:translate-x-1/2">
          <div v-if="window.size.mobile" class="flex flex-col items-center gap-1">
            <span class="text-xs text-white/70">Kod promocyjny</span>
            <div class="relative w-[252px] h-[45px] bg-white rounded-zt border border-dashed border-black
                   cursor-pointer zt-hover"
                 @click="copyToClipBoard()">
              <span class="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 text-xl font-bold text-black">
                {{ bookieData.code }}
              </span>
              <div class="h-8 w-8 absolute top-2.5 right-3 bg-cover
                     bg-[url(/wp-content/themes/zawodtyper/assets/images/ikona_kopiowanie.svg)]"></div>
            </div>
          </div>
          <button class="h-[45px] bg-zt-red rounded-zt text-sm font-medium zt-hover w-[252px] xl:w-[211px]"
                  @click="handleCollectBonusClick">
            ODBIERZ BONUS
          </button>
          <button class="flex justify-center items-center h-[45px] border border-zt-light zt-hover rounded-zt text-sm font-medium
                    w-[252px] xl:w-[211px]"
                  @click="openModal('oferta_powitalna', bonusData); countClicks('Kody promocyjne - 3')">
            SZCZEGÓŁY BONUSU
          </button>
        </div>
      </div>
      <div v-if="sortedOtherBonuses.length > 0"
           id="pozostale_bonusy"
           class="h-11 flex justify-center items-center border-y border-zt-light bg-[#2E3C4F]">
        <span class="uppercase text-zt-more font-medium text-center">{{ bookieData.promo_section2 }}</span>
      </div>
      <div class="relative">
        <BonusDetailsModal v-if="isModalOpen"
                           :selectedBonusData="selectedBonusData"
                           :bookieData="bookieData"
                           @close-modal="closeModal" />
        <template v-for="(bonusData, index) in sortedOtherBonuses" :key="sortedOtherBonuses.bonus_name">
          <div v-if="bonusData.other_bonuses_data.bonus_name && bonusData.other_bonuses_data.bonus_amount"
               class="bg-zt-dark grid justify-start gap-10 border-b border-zt-light cursor-pointer zt-hover group
                 grid-cols-8 pl-1 xl:grid-cols-4 xl:pl-[102px] xl:gap-x-0"
               :class="
                bonusData.other_bonuses_data.bonus_end_datetime
                  ? 'h-14'
                  : 'items-center h-11'"
               @click="openModal('pozostale_bonusy', bonusData); countClicks('Kody promocyjne - 4')">
            <div class="flex items-center justify-end max-w-[300px]  truncate col-span-3 -mr-2 gap-2 xl:col-span-2 xl:mr-0 xl:gap-4">
              <div class="font-medium text-center relative truncate text-xs xl:text-sm">
                <div class="angled-line-through">{{ bonusData.other_bonuses_data.bonus_amount_line_through }}</div>
              </div>
              <div class="font-semibold italic flex gap-1 truncate text-sm xl:text-xl">
                <span class="truncate pr-[1px]">{{ bonusData.other_bonuses_data.bonus_amount }}</span>
              </div>
            </div>
            <div class="-ml-3 col-span-5 xl:col-span-2 xl:-ml-[57px] xl:flex">
              <div class="h-full flex gap-4 xl:self-start">
                <div class="truncate flex flex-col gap-0.5 xl:w-[230px]"
                     :class="[
                       { 'flex-1': window.size.mobile },
                       { 'pt-3 xl:pt-2': bonusData.other_bonuses_data.bonus_end_datetime }
                     ]">
                  <span class="truncate text-xs xl:text-base">
                    {{ bonusData.other_bonuses_data.bonus_name }}
                  </span>
                  <div v-if="bonusData.other_bonuses_data.bonus_end_datetime" class="text-xs font-semibold">
                    <span class="text-zt-more">Do końca: </span>
                    <span class="text-[#F00]">{{ getBonusEndTime(bonusData.other_bonuses_data.bonus_end_datetime) }}</span>
                  </div>
                </div>
                <svg class="min-w-[5px] min-h-[9px] self-center transition-transform group-hover:translate-x-1 mr-4 xl:mr-0"
                     width="5" height="9" viewBox="0 0 5 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M 0.1 8.9 C 0.1 8.9 0 8.8 0 8.8 C 0 8.7 0 8.7 0 8.7 C 0 8.6 0 8.6 0 8.5 C 0 8.5 0.1 8.4 0.1 8.4 L 4.1 4.5 L 0.1 0.6 C 0.1 0.6 0 0.5 0 0.5 C 0 0.4 0 0.4 0 0.3 C 0 0.3 0 0.3 0 0.2 C 0 0.2 0.1 0.1 0.1 0.1 C 0.1 0.1 0.2 0 0.2 0 C 0.3 0 0.3 0 0.4 0 C 0.4 0 0.5 0 0.5 0 C 0.5 0 0.6 0.1 0.6 0.1 L 4.9 4.3 C 4.9 4.3 5 4.3 5 4.4 C 5 4.4 5 4.5 5 4.5 C 5 4.5 5 4.6 5 4.6 C 5 4.7 4.9 4.7 4.9 4.7 L 0.6 8.9 C 0.6 8.9 0.5 9 0.5 9 C 0.5 9 0.4 9 0.4 9 C 0.3 9 0.3 9 0.2 9 C 0.2 9 0.1 8.9 0.1 8.9 Z" fill="white" />
                </svg>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div :id="'funkcjonalnosci-wyroznione-' + bookmakerName.toLowerCase()"
           class="h-11 flex justify-center items-center border-b border-zt-light bg-[#2E3C4F]"
           :class="{ 'border-t': sortedOtherBonuses.length === 0 }">
        <span class="uppercase text-zt-more font-medium text-center">OCENY FUNKCJONALNOŚCI</span>
      </div>
      <div class="bg-zt-dark pt-4 xl:pb-3">
        <div class="relative flex gap-2 px-3 py-2.5 bg-zt-light/35 border border-zt-light rounded-zt items-center h-[68px] mx-2.5 xl:mx-[108px] xl:h-[46px]">
          <p class="text-xs leading-5 font-medium text-zt-more mr-4 w-full text-center">
            Kliknij jedną z poniższych funkcjonalności, aby porównać ją u różnych bukmacherów
          </p>
          <svg v-if="window.size.desktop" class="absolute bottom-0 right-2.5" width="44" height="48" viewBox="0 0 44 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.8755 8.36989L11.1075 12.7397L12.1999 12.1817L9.96795 7.81189L8.8755 8.36989ZM17.3078 7.61237L15.3165 12.097L16.4376 12.5948L18.4289 8.1102L17.3078 7.61237ZM23.2565 13.8519L18.4966 15.0437L18.7946 16.2336L23.5545 15.0418L23.2565 13.8519ZM6.76905 23.6155L10.5248 20.4577L9.73531 19.5188L5.9796 22.6766L6.76905 23.6155ZM4.15759 15.3997L8.95819 16.4151L9.21205 15.215L4.41144 14.1996L4.15759 15.3997ZM33.273 38.6095C37.7989 36.2977 39.4672 30.5071 37.2828 26.2304L35.1898 22.1328L33.9357 19.6775C33.4729 18.7715 32.3704 18.4086 31.4591 18.874C30.5541 19.3363 30.195 20.4443 30.6584 21.3515L30.9364 21.8959L29.844 22.4539L28.4526 19.7298C27.9883 18.821 26.8846 18.4557 25.9733 18.9211C25.0683 19.3834 24.7094 20.4918 25.1752 21.4038L26.0086 23.0355L24.9162 23.5935L23.5248 20.8694C23.0605 19.9605 21.9568 19.5952 21.0455 20.0607C20.1405 20.523 19.7816 21.6313 20.2474 22.5434L22.1969 26.3599L21.1044 26.9179L15.2483 15.453C14.7844 14.5448 13.681 14.1801 12.7697 14.6456C11.8647 15.1078 11.5033 16.2114 11.971 17.127L18.2735 29.4659C14.7969 28.2106 10.4858 27.0786 9.89561 28.9181C9.31785 30.7188 14.059 32.446 22.0057 37.454C25.5861 39.7104 29.1669 40.7062 33.273 38.6095ZM38.3752 25.6724C40.9947 30.8008 38.9608 37.0817 33.8324 39.7012C30.4317 41.4382 26.0322 41.6846 21.2637 38.4461C14.3808 33.7718 7.64565 31.8408 8.70774 28.561C9.46753 26.2146 12.667 26.459 15.8233 27.3657L10.8803 17.6884C10.103 16.1667 10.7034 14.3236 12.2117 13.5531C13.7306 12.7773 15.5695 13.385 16.3425 14.8984L19.1269 20.3497C19.4087 19.7745 19.8727 19.2823 20.4875 18.9683C21.6701 18.3642 23.0449 18.5952 23.9587 19.4379C24.2225 18.7658 24.7224 18.1826 25.4153 17.8287C26.9342 17.0529 28.7704 17.6553 29.5401 19.1622L29.5476 19.1769C29.8297 18.6023 30.2942 18.1111 30.909 17.7971C32.4279 17.0213 34.2647 17.6249 35.0352 19.1333L38.3752 25.6724Z" fill="#93A3BA" fill-opacity="0.1"/>
          </svg>
          <svg v-else width="54" height="60" class="absolute bottom-1 right-0" viewBox="0 0 54 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.9509 10.3274L13.7048 15.719L15.0527 15.0305L12.2988 9.63891L10.9509 10.3274ZM21.355 9.39275L18.898 14.926L20.2813 15.5402L22.7383 10.007L21.355 9.39275ZM28.6947 17.0912L22.8218 18.5617L23.1894 20.03L29.0623 18.5595L28.6947 17.0912ZM8.35189 29.138L12.9858 25.2418L12.0118 24.0833L7.37784 27.9795L8.35189 29.138ZM5.12977 19.0011L11.0529 20.2539L11.3661 18.7731L5.44299 17.5203L5.12977 19.0011ZM41.0534 47.638C46.6376 44.7858 48.696 37.641 46.0008 32.3643L43.4184 27.3086L41.8711 24.2792C41.3001 23.1613 39.9397 22.7134 38.8153 23.2878C37.6987 23.8581 37.2556 25.2252 37.8274 26.3446L38.1704 27.0163L36.8225 27.7048L35.1058 24.3437C34.533 23.2223 33.1712 22.7716 32.0468 23.3459C30.9301 23.9163 30.4873 25.2838 31.0621 26.4091L32.0904 28.4223L30.7425 29.1108L29.0257 25.7497C28.4529 24.6283 27.0911 24.1776 25.9667 24.7519C24.8501 25.3223 24.4072 26.6898 24.982 27.8152L27.3872 32.5241L26.0393 33.2126L18.8139 19.0667C18.2416 17.9462 16.8802 17.4962 15.7557 18.0705C14.6391 18.6409 14.1932 20.0025 14.7702 21.1322L22.5464 36.3564C18.257 34.8076 12.9378 33.4108 12.2095 35.6805C11.4967 37.9023 17.3465 40.0334 27.1513 46.2124C31.5691 48.9965 35.9871 50.225 41.0534 47.638ZM47.3487 31.6758C50.5807 38.0034 48.0712 45.753 41.7436 48.985C37.5477 51.1282 32.1195 51.4322 26.2359 47.4365C17.7435 41.6692 9.43348 39.2866 10.7439 35.2398C11.6814 32.3448 15.629 32.6464 19.5233 33.7651L13.4245 21.8249C12.4654 19.9473 13.2062 17.6732 15.0673 16.7227C16.9413 15.7654 19.2102 16.5152 20.164 18.3825L23.5995 25.1085C23.9471 24.3988 24.5196 23.7915 25.2782 23.404C26.7373 22.6587 28.4335 22.9437 29.5611 23.9835C29.8866 23.1542 30.5033 22.4347 31.3583 21.998C33.2323 21.0408 35.4979 21.7841 36.4476 23.6433L36.4569 23.6615C36.8049 22.9525 37.378 22.3465 38.1366 21.959C40.0107 21.0018 42.277 21.7466 43.2277 23.6077L47.3487 31.6758Z" fill="#93A3BA" fill-opacity="0.1"/>
          </svg>
        </div>
        <BookmakerRating :bookmakerNameFromProps="bookmakerName" :isPromoCodeDetails="true" />
      </div>
      <div class="h-11 flex justify-center items-center border-y border-zt-light bg-[#2E3C4F]">
        <span class="uppercase text-zt-more font-medium text-center">NASZA OCENA</span>
      </div>
      <div class="h-[113px] bg-zt-dark flex flex-col rounded-b-zt justify-center items-center gap-3.5">
        <div class="flex items-center gap-2 h-10" ref="ratingBox">
          <div v-if="showRatingBox" class="flex justify-center items-center">
            <div v-for="i in maxRating" class="animated-star"
                 :class="{ 'before:!content-none': i > getLastStarNumber() }"
                 :style="{ '--star-anim-delay': `${i * 280}ms`,
                           '--star-flash-size': i === getLastStarNumber() ? '90px' : '60px' }">
              <svg viewBox="-1 0 26 26">
                <defs>
                  <linearGradient :id="`half-gold-gradient-${i}`" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop :offset="getStarFillPercentage()" :stop-color="getStarStartColor(i)" />
                    <stop :offset="getStarFillPercentage()" :stop-color="getStarStopColor(i)" />
                  </linearGradient>
                </defs>
                <path :fill="`url(#half-gold-gradient-${i})`" d="M22,10.1c0.1-0.5-0.3-1.1-0.8-1.1l-5.7-0.8L12.9,3c-0.1-0.2-0.2-0.3-0.4-0.4C12,2.3,11.4,2.5,11.1,3L8.6,8.2L2.9,9	C2.6,9,2.4,9.1,2.3,9.3c-0.4,0.4-0.4,1,0,1.4l4.1,4l-1,5.7c0,0.2,0,0.4,0.1,0.6c0.3,0.5,0.9,0.7,1.4,0.4l5.1-2.7l5.1,2.7 c0.1,0.1,0.3,0.1,0.5,0.1l0,0c0.1,0,0.1,0,0.2,0c0.5-0.1,0.9-0.6,0.8-1.2l-1-5.7l4.1-4C21.9,10.5,22,10.3,22,10.1z"></path>
              </svg>
            </div>
          </div>
        </div>
        <span class="text-lg font-semibold">{{ bookieData.rating }}/{{ maxRating }}</span>
      </div>
      <div v-if="commentsData.length > 0 && showOpinions" class="bg-zt-dark flex flex-col pt-5 pb-6 xl:pb-5">
        <div v-for="(comment, index) in commentsData" class="flex flex-col mx-4 gap-1.5 xl:ml-[104px] xl:mr-[111px] xl:gap-2">
          <div class="flex items-center gap-2">
            <span class="text-sm font-semibold hover:underline cursor-pointer zt-hover"
                  @click="window.location.href = '/typer/' + comment.comment_author_id">
              {{ comment.comment_author }}
            </span>
            <span class="text-xs text-[#B5B5B5] font-light">{{ parseDate(comment.comment_date) }}</span>
          </div>
          <span class="text-sm tracking-wide font-light line-clamp-4 mb-1 xl:line-clamp-none xl:mb-0">{{ comment.comment_content }}</span>
          <hr v-if="index < commentsData.length - 1" class="mt-3 mb-5 border-t border-zt-light border-dashed" />
        </div>
        <div class="flex justify-center items-center gap-1 zt-hover cursor-pointer mt-6 xl:mt-5">
          <span class="uppercase text-zt-more underline text-sm"
                @click="smoothScrollToElement('komentarze'); countClicks('Kody promocyjne - 9')">WSZYSTKIE OPINIE ({{ numOfComments }})</span>
          <svg width="11" height="5" viewBox="0 0 11 5" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M 0.1 0.1 C 0.2 0.1 0.2 0 0.3 0 C 0.3 0 0.4 0 0.4 0 C 0.5 0 0.5 0 0.6 0 C 0.6 0 0.7 0.1 0.7 0.1 L 5.5 4.1 L 10.3 0.1 C 10.3 0.1 10.4 0 10.4 0 C 10.5 0 10.5 0 10.6 0 C 10.6 0 10.7 0 10.7 0 C 10.8 0 10.8 0.1 10.9 0.1 C 10.9 0.1 10.9 0.2 11 0.2 C 11 0.3 11 0.3 11 0.4 C 11 0.4 11 0.5 11 0.5 C 10.9 0.5 10.9 0.6 10.9 0.6 L 5.8 4.9 C 5.8 4.9 5.7 5 5.7 5 C 5.6 5 5.6 5 5.5 5 C 5.4 5 5.4 5 5.3 5 C 5.3 5 5.2 4.9 5.2 4.9 L 0.1 0.6 C 0.1 0.6 0.1 0.5 0 0.5 C 0 0.5 0 0.4 0 0.4 C 0 0.3 0 0.3 0 0.2 C 0.1 0.2 0.1 0.1 0.1 0.1 Z" fill="#93A3BA" />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Notice } from '../../../assets/js/Notice';
import utils_mixin from '../../mixins/utils_mixin';
import PromoCodeBox from '../blocks/PromoCodeBox.vue';
import BookmakerRating from '../blocks/BookmakerRating.vue';
import BonusDetailsModal from '../modals/BonusDetailsModal.vue';

export default {
  name: 'PromoCodeDetails',
  inject: ['WP'],
  mixins: [utils_mixin],
  components: {
    PromoCodeBox,
    BookmakerRating,
    BonusDetailsModal
  },
  data() {
    return {
      isLoading: true,
      isModalOpen: false,
      isMainBonusModalOpen: false,
      bookmakerName: this.$attrs.bookmaker ?? '',
      commentsData: JSON.parse(this.$attrs.comments) ?? '',
      numOfComments: this.$attrs.commentscount ?? '',
      bookieData: [],
      sortedOtherBonuses: [],
      selectedBonusData: [],
      rankingBukmacherowPageId: 36,
      maxRating: 5,
      starsType: [],
      isUserWithAdminPanel: false,
      showRatingBox: false,
      showOpinions: false,
      displayFilter: false
    };
  },
  mounted() {
    this.$el.removeAttribute('comments');
    this.$el.parentElement.removeAttribute('data-comments');
    this.getData();
    this.truncateComments();
    this.isUserWithAdminPanel = this.WP.user.role === 'Admin' || this.WP.user.role === 'Moderator' || this.WP.user.role === 'Redaktor';
  },
  methods: {
    getData() {
      const requestSentTime = Date.now();

      axios.get('/wp-json/acf/v3/pages/' + this.rankingBukmacherowPageId + '/sections').then(response => {
        const bookies = response.data.sections[0].bukmacherzy_legalni;
        this.bookieData = bookies.find(bookie => bookie.name.toLowerCase() === this.bookmakerName.toLowerCase());
        this.sortOtherBonuses();
        this.handleDataLoaded(requestSentTime);
        let ratingBoxObserver = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                setTimeout(() => (this.showRatingBox = true), 50);
                observer.unobserve(entry.target);
              }
            });
          },
          {
          threshold: 0,
          rootMargin: '0px 0px 0px 0px'
          }
        );
        this.$nextTick(() => {
          setTimeout(() => {
            this.refreshTooltips();
            const interval = setInterval( () => {
              if (this.$refs.ratingBox !== undefined) {
                clearInterval(interval);
                ratingBoxObserver.observe(this.$refs.ratingBox)
              } 
            }, 200);
          }, 500);
		    });
      });
    },
    sortOtherBonuses() {
      if (this.bookieData.other_bonuses && this.bookieData.other_bonuses.length > 0) {
        this.sortedOtherBonuses = this.bookieData.other_bonuses.sort((a, b) => {
        const isEmptyA = a.other_bonuses_data.bonus_end_datetime === '';
        const isEmptyB = b.other_bonuses_data.bonus_end_datetime === '';

        if (isEmptyA && isEmptyB) {
          return 0;
        } else if (isEmptyA) {
          return 1;
        } else if (isEmptyB) {
          return -1;
        } else {
          const endA = DateTime.fromSQL(a.other_bonuses_data.bonus_end_datetime).toMillis();
          const endB = DateTime.fromSQL(b.other_bonuses_data.bonus_end_datetime).toMillis();

          if (endA < Date.now() && endB < Date.now()) {
            return 0;
          } else if (endA < Date.now()) {
            return 1;
          } else if (endB < Date.now()) {
            return -1;
          } else {
            return endA - endB;
          }
        }
        }).filter(a => {
          if (a.other_bonuses_data.bonus_end_datetime) {
            const endDateTime = DateTime.fromSQL(a.other_bonuses_data.bonus_end_datetime).toMillis();
            const twoHoursAgoMillis = DateTime.now().toMillis() - 2 * 60 * 60 * 1000;
            return endDateTime > twoHoursAgoMillis;
          } else {
            return true;
          }
        });
      }
    },
    handleDataLoaded(requestSentTime) {
      const currentTime = Date.now();
      const timeDifference = currentTime - requestSentTime;
      const delay = timeDifference < 1000 ? 1000 - timeDifference : 0;

      setTimeout(() => {
        this.isLoading = false;
        this.removePlaceholder(this.$attrs.component);
      }, delay);
    },
    truncateComments() {
      this.commentsData.forEach(commentData => {
        if (window.size.desktop && commentData.comment_content.length > 300) {
          commentData.comment_content = commentData.comment_content.slice(0, 300) + '...';
        } else if (window.size.mobile && commentData.comment_content.length > 150) {
          commentData.comment_content = commentData.comment_content.slice(0, 150) + '...';
        }
      });
    },
    copyToClipBoard() {
      if (window.size.mobile) {
        navigator.clipboard.writeText(this.bookieData.code);
				this.countClicks('Kody promocyjne - 1');
        this.addInternalNotification(new Notice().setContent('Skopiowano kod promocyjny'));
      }
    },
    parseDate(commentDate) {
      const currentDateTime = DateTime.now();
      const commentDateTime = DateTime.fromSQL(commentDate);

      const diff = commentDateTime.diff(currentDateTime, ['years', 'months', 'days', 'hours', 'minutes', 'seconds', 'milliseconds']);

      if (diff.months === 0 && diff.years === 0 && diff.days === 0 && diff.hours === 0 && diff.minutes === 0 && diff.seconds >= 0) {
        return `przed chwilą`;
      } else if (diff.months === 0 && diff.years === 0 && diff.days === 0 && diff.hours === 0 && diff.minutes === 0) {
        return `przed chwilą`;
      } else if (diff.months === 0 && diff.years === 0 && diff.days === 0 && diff.hours === 0) {
        return `${-diff.minutes} min. temu`;
      } else if (diff.months === 0 && diff.years === 0 && diff.days === 0) {
        return `${-diff.hours} godz. temu`;
      } else if (diff.days < 0 && diff.months === 0 && diff.years === 0) {
        return `${-diff.days} ${(diff.days === 0 || diff.days === -1) ? 'dzień' : 'dni'} temu`;
      } else if (diff.months < 0 && diff.years === 0) {
        return `${-diff.months} ${this.getPrefix(diff.months, ['miesiąc', 'miesiące', 'miesięcy'])} temu`;
      } else {
        return `${-diff.years} ${this.getPrefix(diff.years, ['rok', 'lata', 'lat'])} temu`;
      }
    },
    getPrefix(diff, arr) {
      if (diff === -1) {
        return arr[0];
      } else if (diff > -5 && diff < -1) {
        return arr[1];
      } else {
        return arr[2];
      }
    },
    getBonusEndTime(bonusEndTime) {
			const endTime = DateTime.fromSQL(bonusEndTime);
			const now = DateTime.now();
			const diff = endTime.diff(now, ['days' ,'hours', 'minutes']).toObject();
			if (diff.days >= 1) {
				return `${ diff.days } ${diff.days > 1 ? 'dni' : 'dzień'}`;
			} else if (diff.hours >= 1) {
				return `${ diff.hours } godz.`;
			} else if (diff.minutes >= 1) {
				return `${ Math.round(diff.minutes) } min.`;
			} else {
				return 'Zakończono';
			}
		},
    openModal(elementId, selectedBonusData) {
      if (elementId === 'oferta_powitalna') {
        this.isMainBonusModalOpen = true;
      } else {
        this.isModalOpen = true;
        this.selectedBonusData = selectedBonusData;
      }
      
      this.blockScrolling();
      this.smoothScrollToElement(elementId, 33);
    },
    closeModal() {
      this.isModalOpen = false;
      this.isMainBonusModalOpen = false;
      this.unblockScrolling();
    },
    getStarStartColor(number) {
      return (number <= Math.ceil(this.bookieData.rating)) ? '#FAFF00' : '#516279';
    },
    getStarStopColor(number) {
      return (number <= this.bookieData.rating) ? '#FAFF00' : '#516279';
    },
    getLastStarNumber() {
      return Math.ceil(this.bookieData.rating);
    },
    getStarFillPercentage() {
      return `${(this.bookieData.rating - Math.floor(this.bookieData.rating)) * 100}%`;
    },
    handleCollectBonusClick() {
      countClicks('Kody promocyjne - 2');
      axios.post(WP.ajaxUrl, {
        endpoint: 'api_count_outerlink_click',
        link: this.bookieData.link,
      });
      window.open(this.bookieData.link, '_blank');
    },
  }
};
</script>

<style scoped>
.angled-line-through {
	@apply relative inline-block;

	&::after {
		content: '';
		@apply absolute -left-1 -right-1 border-t-[2px] top-[6px]  border-solid border-white/75 xl:top-[9px];
	}
}
.simple-line-through {
	@apply relative inline-block;

	&::after {
		content: '';
		@apply absolute -left-1 -right-1 top-[11px] border-t-[2px] border-solid border-white/75;
	}
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease-in-out;
}
.fade-enter-from {
  opacity: 0;
}
.fade-enter-to {
  opacity: 1;
}
.fade-2-enter-active {
  animation: blurAnimation 3s;
}

@keyframes blurAnimation {
  0% {
    filter: blur(5px);
    opacity: 95%;
  }
  20% {
    filter: blur(40px);
    opacity: 80%;
  }
  90% {
    filter: blur(60px);
    opacity: 10%;
  }
  100% {
    filter: blur(100px);
    opacity: 0;
  }
}

@keyframes star-circle-flash {
  0% {
    width: 0;
    height: 0;
    opacity: 1;
  }
  50% {
    width: var(--star-flash-size);
    height: var(--star-flash-size);
  }
  70%, 100% {
    opacity: 0;
  }
}

.animated-star {
  @apply relative;

  svg {
    @apply w-[40px] h-[40px];
    transform: scale3d(0, 0, 0);
    animation: show-up-small 0.6s forwards;
    animation-delay: var(--star-anim-delay);
  }

  &:before {
    @apply absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2;
    content: '';
    border-radius: 50%;
    background: radial-gradient(circle, #FAFF00 0%, rgba(255,255,255,0) 80%);
    animation: star-circle-flash 1.8s;
    animation-delay: var(--star-anim-delay);
  }
}
</style>